import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum PRESENTATION_TABS_INDEX {
    RGRL = 0,
    RAR = 1,
    SVCC = 2,
}

interface VisitsInitialState {
    currentTab: number;
}

const initialState: VisitsInitialState = {
    currentTab: PRESENTATION_TABS_INDEX.RGRL
};

const presentationsSliceBO = createSlice({
    name: 'presentationsBO',
    initialState,
    reducers: {
        setCurrentTab: (state, action: PayloadAction<number | null>) => {
            state.currentTab = action.payload ?? PRESENTATION_TABS_INDEX.RGRL;
        }
    }
});

export const { setCurrentTab } = presentationsSliceBO.actions;
export default presentationsSliceBO.reducer;
